import { FC } from 'react'
import { StyleProp, StyleSheet, ViewStyle } from 'react-native'
import { Card, Text } from 'react-native-paper'
import { FontsEnum } from '../../constants/fonts'

interface ElevatedRectangleProps {
    children: string
    color?: string | false
    textColor?: string | false
    style?: StyleProp<ViewStyle>
}

const ElevatedRectangle: FC<ElevatedRectangleProps> = ({ children, color, textColor, style }) => {
    return (
        <Card
            elevation={1}
            style={[styles.container, color ? { backgroundColor: color } : false, style]}
        >
            <Text style={[styles.text, textColor ? { color: textColor } : false]}>{children}</Text>
        </Card>
    )
}

const styles = StyleSheet.create({
    container: {
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#FFFFFF',
        borderRadius: 4,
    },
    text: {
        fontFamily: FontsEnum.RUBIK_400_REGULAR,
        fontSize: 64,
        fontWeight: 'bold',
    },
})

export default ElevatedRectangle
